<template>
<div id="app">
  <head>
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap"
    />
    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Modak&display=swap" />
    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Yellowtail&display=swap" />
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Lato:wght@100;300&family=Modak&display=swap"
    />
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Merienda+One&display=swap"
    />
  </head>
  <Navigation />
  <div>
    <img style="width: 10%; height:auto;" alt="The Fancy Mutt logo" src="./assets/logo.png" />
  </div>
  <router-view />
</div>
</template>

<script>
import Navigation from "./components/Navigation.vue";

export default {
  name: "App",
  components: {
    Navigation,
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
